import {Dispatch, FC, SetStateAction} from "react";
import { Link, useLocation } from "react-router-dom";

interface AdminNavbarListItemProps {
    item: {
        label: string;
        path: string;
    };
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const AdminNavbarListItem: FC<AdminNavbarListItemProps> = ({ item, setIsOpen }) => {
    const location = useLocation();
    const isActive = location.pathname === item.path;

    return (
        <li>
            <Link
                to={item.path}
                className={`block px-4 py-2 hover:bg-gray-700 lg:inline-block ${isActive && "font-bold"}`}
                onClick={() => setIsOpen(false)}
            >
                {item.label}
            </Link>
        </li>
    );
};